import axios from "axios";
import { endpoints } from "Modules/accounts/api/endpoints";

export const endpoint = "/api/account";

export const verifyNewUsername = (token) =>
  axios.get(`/api/new-username-verify/${token}`);

export const updateUsername = (username, password) => {
  let form = new FormData();
  form.append("new_username", username);
  form.append("password", password);
  return axios.post(`${endpoint}/update-username`, form);
};

export const loginUser = (username, password) => {
  let form = new FormData();
  form.append("username", username);
  form.append("password", password);
  return axios.post("/api/login", form);
};

export const changeUserPassword = (
  currentPassword,
  newPassword,
  repeatNewPassword
) => {
  let form = new FormData();
  form.append("current_password", currentPassword);
  form.append("new_password", newPassword);
  form.append("new_password_confirmation", repeatNewPassword);
  return axios.post(`${endpoint}/change-password`, form);
};

export const updateUserEmail = (newEmail, password) => {
  let form = new FormData();
  form.append("email", newEmail);
  form.append("password", password);
  return axios.post(`${endpoint}/update-email`, form);
};

export const verifyNewPassword = (token) => {
  return axios.get("/api/new-password-confirm", {
    params: {
      token,
    },
  });
};

export const verifyNewEmail = (token) => {
  return axios.get("/api/new-email-verify", {
    params: {
      token,
    },
  });
};

export const verify2FA = (username, password, code) => {
  let form = new FormData();
  form.append("username", username);
  form.append("password", password);
  form.append("two_auth_token", code);
  return axios.post(`/api/two-factor-login`, form);
};

export const confirmEnableTwoFactorAuth = (token) =>
  axios.get(`/api/enable-two-factor-auth/${token}`);

export const confirmDisableTwoFactorAuth = (token) =>
  axios.get(`/api/disable-two-factor-auth/${token}`);

export const requestNew2FACode = (username, password) => {
  let form = new FormData();
  form.append("username", username);
  form.append("password", password);
  return axios.post(`/api/resend-factor-login`, form);
};

export const requestUsernameRecovery = (email, password) =>
  axios.post(`/api/recover-username/request`, {
    email,
    password,
  });

export const verifyUsernameRecovery = (token) =>
  axios.post(`/api/recover-username/verify`, { token });

export const switchToUser = (userId) => {
  return axios.post(endpoints.switchToUser(userId));
};

export const getAccountUsers = () =>
  axios.get(endpoints.getAccountUsers).then((res) => res.data.data);
